module.exports = __webpack_public_path__ + "img/MyEnrollLogo_Variation.50e8756f.svg";